import request from "@/utils/request";

export function phoneIsExist(phone,category,process){
    return request.get('/submitinfo/checkPhoneIsExist',{
        params:{
            phone,category,process
        }
    })
}

export function addUser({name,phone,process,category}){
    return request.post('/submitinfo/addUser',{
            name,phone,process,category
    })
}